import React from "react";
import { MapPin } from "lucide-react";
import { SERVICE_AREA, BRAND } from "@/lib/site";

export default function ServiceArea() {
  return (
    <section
      data-testid="service-area"
      className="section-lw relative bg-[#F4F5F7] text-black"
    >
      <div className="container-lw">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.2fr] lg:gap-20">
          <div>
            <div className="eyebrow text-[#4F0DFF]">
              <span className="h-1.5 w-1.5 rounded-full bg-[#4F0DFF]" />
              Service area
            </div>
            <h2 className="mt-5 h-display text-4xl md:text-5xl lg:text-6xl">
              Currently serving <br />
              <span className="text-gradient-lw">southeastern Ontario.</span>
            </h2>
            <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-[#4A5359]">
              LotWise Auto operates across the Ottawa Valley and eastern
              Ontario corridor, with active service into Ottawa, Kingston,
              Cornwall, Pembroke, Petawawa, Perth, Arnprior, Renfrew,
              Carleton Place, and Rockland. Dealerships in the surrounding
              regions, Lanark County, Renfrew County, Prescott and Russell,
              Stormont Dundas and Glengarry, Leeds and Grenville, and
              Frontenac County, are welcome to join the waitlist as coverage
              expands.
            </p>

            <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-black/10 bg-white px-4 py-2 text-sm">
              <MapPin className="h-4 w-4 text-[#4F0DFF]" />
              Priority region: {BRAND.region}
            </div>
          </div>

          <div className="grid gap-6">
            <div>
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#79858D]">
                Priority cities
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {SERVICE_AREA.primary.map((c) => (
                  <span
                    key={c}
                    data-testid={`region-city-${c.toLowerCase().replace(/\s+/g, "-")}`}
                    className="rounded-full border border-black/10 bg-white px-4 py-2 text-sm font-medium"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </div>

            <div>
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#79858D]">
                Regional coverage
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {SERVICE_AREA.regions.map((r) => (
                  <span
                    key={r}
                    className="rounded-full border border-black/10 bg-[#EBEDF0] px-4 py-2 text-sm text-[#2A2F33]"
                  >
                    {r}
                  </span>
                ))}
              </div>
            </div>

            <div className="rounded-2xl border border-black/10 bg-white p-6">
              <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#79858D]">
                Outside the region?
              </div>
              <p className="mt-3 text-sm leading-relaxed text-[#2A2F33]">
                LotWise Auto accepts waitlist applications from all other
                regions. Waitlisted stores are contacted in order as
                coverage expands. The standard travels.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
